import type { UserPreferences } from "@Shared/schemas/users/userSchemas";

/** Saved values that changed, excluding unrelated settings still being edited. */
export function getChangedPreferences(previous: UserPreferences | undefined, current: UserPreferences): UserPreferences {
  return Object.fromEntries(Object.entries(current).filter(([key, value]) => !previous || !Object.is(previous[key], value)));
}
